import React from 'react';
import {connect} from 'react-redux';
import Currency from '../../../components/numbers/Currency';
import DateTime from '../../../components/numbers/DateTime';
import ArrLeftButton from '../../../components/buttons/ArrLeftButton';
import ArrRightButton from '../../../components/buttons/ArrRightButton';
import {Set} from 'immutable';
import {setAllowSale, setForbidSale} from '../../../../common/categories/actions';
import {
    fetchHabitueDetail, clearHabitueDetail, showDetailDebtItems, chooseDebtToPay, fetchHabitueBillsToPay,
    toggleBillCheckbox, clearBillCheckbox, setDebtToPrint
} from '../../../../common/menu/credit/debtDetail/actions';
import {showPopupInMenu} from '../../../../common/menu/actions';
import Popup from '../../popup/Popup';
import DetailPopup from './DetailPopup';
import {openPaymentPopup} from '../../../../common/paymentPopup/actions';
import {backToMenuHabitues} from '../../../../common/menu/credit/habitues/actions';
import {isNeedArrayPrint, preparePrintArray, print} from '../../../../common/lib/util';

class HabitueDetail extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        id: React.PropTypes.string,
        page: React.PropTypes.number,
        limit: React.PropTypes.number,
        max: React.PropTypes.number,
        printingInProgress: React.PropTypes.bool,
        showPopupInMenu: React.PropTypes.func,
        toggleBillCheckbox: React.PropTypes.func,
        setAllowSale: React.PropTypes.func,
        clearBillCheckbox: React.PropTypes.func,
        openPaymentPopup: React.PropTypes.func,
        backToMenuHabitues: React.PropTypes.func,
        setForbidSale: React.PropTypes.func,
        selectedBills: React.PropTypes.object,
        bills: React.PropTypes.object,
        branch: React.PropTypes.object,
        habitue: React.PropTypes.object,
        showDetailDebtItems: React.PropTypes.func,
        setDebtToPrint: React.PropTypes.func,
        clearHabitueDetail: React.PropTypes.func,
        chooseDebtToPay: React.PropTypes.func,
        fetchHabitueBillsToPay: React.PropTypes.func,
        fetchHabitueDetail: React.PropTypes.func,
        deviceId: React.PropTypes.number,
        organization: React.PropTypes.object,
        bar: React.PropTypes.object,
        printType: React.PropTypes.string,
        printAddress: React.PropTypes.string,
        printLength: React.PropTypes.number
    };

    constructor(props) {
        super(props);

        this.nextPage = this.nextPage.bind(this);
        this.prevPage = this.prevPage.bind(this);
        this.showBill = this.showBill.bind(this);
        this.openMergeBills = this.openMergeBills.bind(this);
        this.openMergeBill = this.openMergeBill.bind(this);
        this.openMergeBillsAll = this.openMergeBillsAll.bind(this);
        this.backToHabitues = this.backToHabitues.bind(this);
        this.countSelectedTablesPrice = this.countSelectedTablesPrice.bind(this);
        this.printBill = this.printBill.bind(this);
    }

    printBill(bill) {
        const {
            setDebtToPrint, bar, organization, branch, deviceId, printType, printAddress, printLength, setAllowSale,
            setForbidSale, msg
        } = this.props;
        setDebtToPrint(bill);

        const printArray = !!isNeedArrayPrint(printType)
            ? preparePrintArray(bar, organization, bill, branch, null, null, null, null, deviceId, msg)
            : null;

        setForbidSale();
        print(printType, printAddress, printArray, false, printLength, false, null);
        setTimeout(function () {
            setAllowSale();
        }, 3500);
    }

    backToHabitues() {
        const {backToMenuHabitues} = this.props;
        backToMenuHabitues();
    }

    showBill(billId) {
        const {showPopupInMenu, showDetailDebtItems} = this.props;
        showDetailDebtItems(billId);
        showPopupInMenu(true);
    }

    nextPage() {
        const {fetchHabitueDetail, id, limit, page} = this.props;
        fetchHabitueDetail(id, limit, page + 1);
    }

    prevPage() {
        const {fetchHabitueDetail, id, limit, page} = this.props;
        fetchHabitueDetail(id, limit, page - 1);
    }

    componentWillMount() {
        const {fetchHabitueDetail, id, limit, page} = this.props;
        fetchHabitueDetail(id, limit, page);
    }

    componentWillUnmount() {
        const {clearHabitueDetail} = this.props;
        clearHabitueDetail();
    }

    openMergeBill(billId) {
        const {openPaymentPopup, chooseDebtToPay} = this.props;
        chooseDebtToPay(billId);
        openPaymentPopup();
    }

    openMergeBills(selectedBills) {
        const {fetchHabitueBillsToPay, id} = this.props;
        fetchHabitueBillsToPay(id, selectedBills.keySeq());
    }

    openMergeBillsAll() {
        const {fetchHabitueBillsToPay, id, clearBillCheckbox} = this.props;
        clearBillCheckbox();
        fetchHabitueBillsToPay(id, Set());
    }

    countSelectedTablesPrice(selectedBills) {
        return selectedBills.reduce((sum, bill) => sum + bill, 0);
    }

    render() {
        const {
            habitue, bills, max, page, limit, selectedBills, toggleBillCheckbox, msg, printingInProgress
        } = this.props;
        if (!habitue) return null;

        return (
            <div className="menuPage">
                <Popup body={<DetailPopup/>}/>

                <div className="menuPage-header">
                    <div className="menuPage-header-title" style={{width: '50%'}}>
                        <div className="menuPage-title">{msg.credits.title} > {habitue.get('fullName')}</div>
                    </div>
                  <div className="menuPage-header-key" style={{width: '10%'}}>
                    <div className={`boxBtn color-greenLight`}>
                        <div className={`boxBtn-inner `}
                             onClick={this.backToHabitues}>
                          <svg className={`shape shape-back`}>
                            <use xlinkHref={`#shape-back`}></use>
                          </svg>
                        </div>
                    </div>
                  </div>
                  <div className="menuPage-header-key" style={{width: '10%'}}>
                    <div className={`boxBtn color-white ${page < 1 ? 'disabled' : ''}`}
                         onClick={() => this.prevPage()}>
                        <ArrLeftButton/>
                    </div>
                  </div>
                  <div className="menuPage-header-key" style={{width: '10%'}}>
                    <div
                        className={`boxBtn color-white ${max <= limit || page === (Math.ceil(max / limit) - 1) ? 'disabled' : ''}`}
                        onClick={() => this.nextPage()}>
                        <ArrRightButton/>
                    </div>
                  </div>
                  <div className="menuPage-header-key" style={{width: '20%'}}>
                    {selectedBills.size > 0 &&
                        <div className={`boxBtn color-green`}
                             onClick={() => this.openMergeBills(selectedBills)}>
                            <div className={`boxBtn-inner`}>
                                <span>
                                {msg.credits.paySelected} (<Currency value={this.countSelectedTablesPrice(selectedBills)}
                                                           currency={habitue.get('currency')}/>)
                                </span>
                            </div>
                        </div>
                    }
                    {selectedBills.size === 0 &&
                        <div className={`boxBtn color-green ${!!bills && bills.size > 0 ? '' : 'disabled' }`}
                             onClick={() => this.openMergeBillsAll()}>
                            <div className={`boxBtn-inner`}>
                                <span>
                                    {msg.credits.payAll} (<Currency value={Math.round(habitue.get('amount'))}
                                                      currency={habitue.get('currency')}/>)
                                </span>
                            </div>
                        </div>
                    }
                  </div>
                </div>

              <div className="menuPage-content">
                <div className="table">
                    <div className="table-head">
                        <div className="table-head-row">
                            <div className="table-head-cell" style={{width: '5%'}}>
                               <span/>
                            </div>
                            <div className="table-head-cell" style={{width: '20%'}}>
                                <span>{msg.credits.date}</span>
                            </div>
                            <div className="table-head-cell" style={{width: '20%'}}>
                                <span>{msg.credits.table}</span>
                            </div>
                            <div className="table-head-cell" style={{width: '20%'}}>
                                <span>{msg.credits.entered}</span>
                            </div>
                            <div className="table-head-cell" style={{width: '35%'}}>
                                <span>{msg.credits.debt}</span>
                            </div>
                        </div>
                    </div>
                    <div className="table-body">
                        {!!bills && bills.map(bill =>
                            <div className="table-row" key={`bill-${bill.get('id')}`}>
                                <div className="table-cell"
                                     onClick={() => toggleBillCheckbox(bill.get('id'), bill.get('totalAmount'))}
                                     style={{width: '5%'}}>
                                    <div className={`boxBtn text-black`}>
                                        <div className="boxBtn-inner">
                                            <input className="checkbox"
                                                   checked={selectedBills.has(bill.get('id'))}
                                                   type="checkbox" />
                                        </div>
                                    </div>
                                </div>
                                <div className="table-cell"
                                     style={{width: '20%'}}
                                     onClick={() => this.showBill(bill.get('id'))}>
                                    <div className={`boxBtn text-black text-left`}>
                                        <div className="boxBtn-inner">
                                            <DateTime value={bill.get('credit')}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="table-cell"
                                     onClick={() => this.showBill(bill.get('id'))}
                                     style={{width: '20%'}}>
                                    <div className={`boxBtn text-black text-left`}>
                                        <div className="boxBtn-inner">
                                            {bill.get('title')}
                                        </div>
                                    </div>
                                </div>
                                <div className="table-cell"
                                     onClick={() => this.showBill(bill.get('id'))}
                                     style={{width: '20%'}}>
                                    <div className={`boxBtn text-black`}>
                                        <div className="boxBtn-inner">
                                            {bill.get('userEntity')}
                                        </div>
                                    </div>
                                </div>
                                <div className="table-cell"
                                     onClick={() => this.showBill(bill.get('id'))}
                                     style={{width: '15%'}}>
                                    <div className={`boxBtn text-black text-right`}>
                                        <div className="boxBtn-inner">
                                            <Currency value={Math.round(bill.get('totalAmount'))}
                                                      currency={bill.get('currency')}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="table-cell"
                                     style={{width: '10%'}}>
                                    <div className={`boxBtn color-green ${!printingInProgress ? '' : 'disabled'}`}
                                         onClick={() => this.printBill(bill)}>
                                        <div className="boxBtn-inner">
                                            <span>{msg.credits.print}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="table-cell"
                                     style={{width: '10%'}}>
                                    <div className={`boxBtn color-green ${!printingInProgress ? '' : 'disabled'}`}
                                         onClick={() => this.openMergeBill(bill.get('id'))}>
                                        <div className="boxBtn-inner">
                                            <span>{msg.credits.pay}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
              </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    branch: state.branches.get('branch'),
    id: state.menuDebtDetail.get('id'),
    limit: state.menuDebtDetail.get('limit'),
    page: state.menuDebtDetail.get('page'),
    max: state.menuDebtDetail.get('max'),
    habitue: state.menuDebtDetail.get('habitue'),
    bills: state.menuDebtDetail.get('bills'),
    selectedBills: state.menuDebtDetail.get('selectedBills'),
    bar: state.bars.get('bar'),
    organization: state.categories.get('organization'),
    printType: state.device.get('printType'),
    printingInProgress: state.categories.get('printingInProgress'),
    printAddress: state.device.get('printAddress'),
    printLength: state.device.get('printLength'),
    deviceId: state.device.get('id')
}), {
    fetchHabitueDetail, clearHabitueDetail, showPopupInMenu, showDetailDebtItems, openPaymentPopup, chooseDebtToPay,
    fetchHabitueBillsToPay, backToMenuHabitues, toggleBillCheckbox, clearBillCheckbox, setDebtToPrint, setAllowSale,
    setForbidSale
})(HabitueDetail);



// WEBPACK FOOTER //
// ./src/browser/menu/credit/debtDetail/HabitueDetail.js